angular.module("beneInLeasing.components", []).component("beneInLeasing", {
  templateUrl: "ng/components/richiestaPreventivo/beneInLeasing/beneInLeasing.view.html",
  bindings: {
    model: "=",
    product: "<",
    exportValidityBeneInLeasing: "&",
    initialTabIndex: "="
  },
  controllerAs: "beneInLeasingCtrl",
  controller: function BeneInLeasing(
    $financialApiService,
    $typeDomainService,
    Motorizzazione
  ) {
    var self = this;

    self.$onInit = function () {
      self.supportModel = {
        dropdown: {
          listOfCarBrands: []
        },
        initialIndex: 0,
        motorizzazione: [],
        alimentazione: ''
      }

      self.supportModel.initialIndex = self.initialTabIndex || 0;
      if (self.model.preventivo.prodotto.bene.motorizzazione.id) {
        self.supportModel.alimentazione = self.model.preventivo.prodotto.bene.motorizzazione;
      }
      listOfMotorizzazione();
      validationComponent();
    };

    self.$onChanges = function (changed) {
      if (changed && changed.product && changed.product.currentValue) {
        if (self.product.id && self.product.isTargato) {
          getlistOfCarBrands(self.product.id);
          self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build();
          self.supportModel.alimentazione = '';
        } else if (!self.product.isTargato) {
          self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build();
          self.supportModel.alimentazione = '';
        }
        self.model.preventivo.prodotto.bene.marcaVeicolo = "";
      }

      validationComponent();
    }

    self.handleChange = function (property, value) {
      switch (property) {
        case "stato":
        case "annoCostruzione":
        case "marcaVeicolo":
        case "descrizione":
          self.model.preventivo.prodotto.bene[property] = value;
          if (property == 'annoCostruzione') {
            var date = new Date();
            var year = date.getFullYear();
            var convertYearToInt = parseInt(value);
            if (convertYearToInt > year) {
              self.errorYear = true;
            } else {
              self.errorYear = false;
            }
          }
          if (property == 'marcaVeicolo') {
            self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build();
            self.supportModel.alimentazione = "";
          }
          break;
        case "fornitore":
          self.model.preventivo.fornitore.descrizione = value;
          break;
        case "motorizzazione":
          if (value) {
            self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build({
              description: value.description,
              id: value.value,
              selected: true
            })
          } else {
            self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build();
          }
          break;
        default:
          break;
      }

      validationComponent();
    }

    var getlistOfCarBrands = function (codProduct) {
      $financialApiService.getlistOfCarBrands(codProduct)
        .then(function (list) {
          self.supportModel.dropdown.listOfCarBrands = list;
        })
        .catch(function (error) {
          console.log(error);
        })
    }

    var validationComponent = function () {

      var date = new Date();
      var year = date.getFullYear();
      var convertYearToInt = parseInt(self.model.preventivo.prodotto.bene.annoCostruzione);

      var test = convertYearToInt <= year &&
        self.model.preventivo.prodotto.bene.descrizione &&
        self.model.preventivo.fornitore.descrizione &&
        ((!self.model.preventivo.prodotto.marcaMandatory) || (self.model.preventivo.prodotto && self.model.preventivo.prodotto.marcaMandatory && self.model.preventivo.prodotto.bene.marcaVeicolo && self.model.preventivo.prodotto.bene.marcaVeicolo.id))

      if (test) {
        self.exportValidityBeneInLeasing({
          validity: true
        })
      } else {
        self.exportValidityBeneInLeasing({
          validity: false
        })
      }

    }

    var listOfMotorizzazione = function () {
      $typeDomainService.getDomainSet('BENE', 'MOTORIZZAZIONE')
        .then(function (response) {
          self.supportModel.motorizzazione = response.domainList;
        })
    }
  }
})